<div class='container'>
    <div class='first-row'>
        <div class='icon' ngClass="_{{note.Icon}}">
            <span class="hd-icon hd-icon-filetype-document integration-icon"></span>
        </div>
        <div class='title'>
            <div class="subject">
                {{note.Subject}}
            </div>
            <div class='date-user-info'>
                {{ 'Snapshot_Notes_Modified_By_Caption' | saI18n }} {{ note.displayName ? note.displayName : note.UserInfoId }} {{ 'Snapshot_Notes_On_Caption' | saI18n }} {{ note.EditDate }}
            </div>
        </div>
    </div>

    <div class="note" #noteDiv [innerHtml]="note.Description" [ngClass]="{'show-more': isShowMore, 'show-less': !isShowMore}"></div>

    <div *ngIf="IsLargeNote()">
        <span #showMore class="more-less" (click)="toggle()">
            {{ isShowMore ? ('Snapshot_Notes_Show_More_Caption' | saI18n) : ('Snapshot_Notes_Show_Less_Caption' | saI18n) }}
        </span>
    </div>
</div>